import { cn } from "@/lib/utils";
import { forwardRef, type HTMLAttributes } from "react";

export interface GolfCardProps extends HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
}

const GolfCard = forwardRef<HTMLDivElement, GolfCardProps>(
  ({ className, hover = true, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "card-golf p-6",
          hover && "hover:shadow-lg hover:scale-[1.01]",
          className
        )}
        {...props}
      />
    );
  }
);
GolfCard.displayName = "GolfCard";

const GolfCardHeader = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 pb-4", className)}
    {...props}
  />
));
GolfCardHeader.displayName = "GolfCardHeader";

const GolfCardTitle = forwardRef<
  HTMLParagraphElement,
  HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn("font-semibold text-lg leading-none tracking-tight", className)}
    {...props}
  />
));
GolfCardTitle.displayName = "GolfCardTitle";

const GolfCardDescription = forwardRef<
  HTMLParagraphElement,
  HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
));
GolfCardDescription.displayName = "GolfCardDescription";

const GolfCardContent = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("pt-0", className)} {...props} />
));
GolfCardContent.displayName = "GolfCardContent";

const GolfCardFooter = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center pt-4", className)}
    {...props}
  />
));
GolfCardFooter.displayName = "GolfCardFooter";

export {
  GolfCard,
  GolfCardHeader,
  GolfCardTitle,
  GolfCardDescription,
  GolfCardContent,
  GolfCardFooter,
};